<template>
    <v-row>
        <v-col cols="12" sm="6" md="4">
            <v-list>
                 <show-field :value="item.branch.name" :label="$t('delivery.stockTransaction.labels.branch')" icon="store"/>
                 <show-field :value="item.reason" :label="$t('delivery.stockTransaction.labels.reason')" icon="description"/>
            </v-list>
        </v-col>

        <v-col cols="12" sm="6" md="4">
            <v-list>
                 <show-field :value="item.branchDestination.name" :label="$t('delivery.stockTransaction.labels.branchDestination')" icon="store"/>
                 <show-field :value="item.items.map(i => i.name).join(', ')" :label="$t('delivery.stockTransaction.labels.items')" icon="inventory"/>
            </v-list>
        </v-col>

        <v-col cols="12" sm="6" md="4">
            <v-list>
                 <show-field :value="item.operation" :label="$t('delivery.stockTransaction.labels.operation')" icon="move_up"/>
                 <show-field :value="item.user.username" :label="$t('delivery.stockTransaction.labels.user')" icon="person"/>
            </v-list>
        </v-col>

    </v-row>
</template>
<script>
    import {ShowField} from '@dracul/common-frontend'
     
    
    export default {
        name: 'StockTransactionShowData',
        components: {ShowField},
        
        props: {
            item: {type: Object, required: true}
        }
    }
</script>

